import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SECTORS } from "@/data/media";
import { Seo } from "@/components/Seo";
import { ArrowRight } from "lucide-react";

export default function Sectors() {
  const { t } = useLang();
  return (
    <div data-testid="sectors-page">
      <Seo page="sectors" />
      <PageHero overline={t.sectors.overline} title={t.sectors.title} image={SECTORS.hotel} intro={t.sectors.intro} />

      <section className="py-16 md:py-24 bg-cream">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 space-y-16 md:space-y-24">
          {t.sectors.items.map((item, i) => {
            const reversed = i % 2 === 1;
            return (
              <Reveal key={item.key}>
                <div className={`grid md:grid-cols-2 gap-8 md:gap-14 items-center ${reversed ? "md:[direction:rtl]" : ""}`}>
                  <div className="[direction:ltr] overflow-hidden group">
                    <div className="aspect-[4/3] overflow-hidden bg-ink">
                      <img
                        src={SECTORS[item.key]}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms]"
                      />
                    </div>
                  </div>
                  <div className="[direction:ltr]">
                    <span className="font-serif-display text-6xl text-brass/25">{String(i + 1).padStart(2, "0")}</span>
                    <h2 className="font-serif-display font-light text-3xl md:text-4xl tracking-tight text-ink -mt-4">{item.title}</h2>
                    <div className="brass-line w-20 my-5" />
                    <p className="text-ink/70 text-lg leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* Materials */}
      <section className="relative py-24 md:py-32 bg-ink text-white overflow-hidden">
        <img src={SECTORS.tessuti} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <p className="overline mb-5">{t.common.madeInItaly}</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl tracking-tight">{t.sectors.materialsTitle}</h2>
            <p className="mt-6 text-white/70 text-lg leading-relaxed max-w-2xl mx-auto">{t.sectors.materialsText}</p>
            <Link to="/contatti" data-testid="sectors-cta-link" className="mt-10 inline-flex items-center gap-2 bg-brass text-white px-9 py-4 text-sm tracking-wide uppercase font-medium hover:bg-brass-dark transition-colors">
              {t.common.contactUs} <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
